/**
 * getters
 */
// export const getters: GetterTree<SearchState, RootState> = {
//   addresslist: (state: SearchState) => state.cardnumber,
// };
/**
 * mutations
 */
export var mutations = {
  // 搜索关键字变化
  KEYWIRDSCHANGE: function KEYWIRDSCHANGE(state, payload) {
    state.kewords = payload;
  }
};
/**
 * state
 */
export var state = {
  kewords: ''
};
var namespaced = true;
export var search = {
  namespaced: namespaced,
  state: state,
  // getters,
  mutations: mutations
};